module.exports = {"api":{"authorization_header":"","base_url":"https://print.rc05.resa2.stadline.tech/api","file_base_url":"https://print.rc05.resa2.stadline.tech/api"},"idle":{"minutes":1},"weeks":{"display":3}};


//////////////////
// WEBPACK FOOTER
// ../config/index.js
// module id = 54
// module chunks = 0